var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"span",domProps:{"innerHTML":_vm._s(_vm.$t('iap.more-information', {termsLink: _vm.termsLink, privacyLink: _vm.privacyLink}))}})}
var staticRenderFns = []

export { render, staticRenderFns }